import PriceListItem from './PriceListItem';
import { PriceListItemProps, PriceListItemValueProps } from './types';

export type { PriceListItemProps, PriceListItemValueProps };
export default PriceListItem;
